import PropTypes from 'prop-types'
import { Card, CardBody } from 'reactstrap'

const StatCard = ({ icon, iconBgColor, title, value, subtitle, children }) => {
  return (
    <Card className="border-0 shadow-sm h-100">
      <CardBody className="p-3">
        <div className="d-flex align-items-start">
          {icon && (
            <div
              className="rounded p-2 me-3"
              style={{ backgroundColor: iconBgColor || '#F9FAFB' }}
            >
              {icon}
            </div>
          )}
          <div className="flex-grow-1">
            {title && <div className="text-muted small mb-1">{title}</div>}
            {value && <div className="h5 mb-0 fw-bold">{value}</div>}
            {subtitle && <div className="text-muted small">{subtitle}</div>}
            {children}
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

StatCard.propTypes = {
  icon: PropTypes.node,
  iconBgColor: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  subtitle: PropTypes.string,
  children: PropTypes.node,
}

export default StatCard
